import type {
  Event,
  EventDetails,
  EventsOverview,
  LimitedEvent,
  LiveEvent,
} from "mws-ts-v2-sdk";

export const getEventRoute = (
  event: Event | LimitedEvent | LiveEvent | EventsOverview | EventDetails,
) => `/event/${event.slug}`;
